{
    "name": "dashboard",
    "version": "2026.2.0",
    "license": "Proprietary",
    "scripts": {
        "start": ".\\startTrackingWebApp.bat",
        "start:local": "ng serve --host 0.0.0.0 --ssl --ssl-key \"..\\Certificates\\dev-local.key\" --ssl-cert \"..\\Certificates\\dev-local.crt\"",
        "build": "npx ng build",
        "test": "npx ng test",
        "test:coverage": "npx ng test --coverage --watch=false",
        "lint": "npx ng lint",
        "compodoc": "npx compodoc -p tsconfig.json",
        "mock": "concurrently --kill-others \"npx ng serve\" \"cd ./src/app-settings && node ./index.js\" \" cd ./mock && node --inspect=9230 --watch ./services.js\"",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org wolters-kluwer-limited --project taxprep-dashboard-web-app ./dist && sentry-cli sourcemaps upload --org wolters-kluwer-limited --project taxprep-dashboard-web-app ./dist"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.2.23",
        "@angular/cdk": "^21.2.14",
        "@angular/common": "^21.2.23",
        "@angular/compiler": "^21.2.23",
        "@angular/core": "^21.2.23",
        "@angular/forms": "^21.2.23",
        "@angular/localize": "^21.2.23",
        "@angular/platform-browser": "^21.2.23",
        "@angular/platform-browser-dynamic": "^21.2.23",
        "@angular/router": "^21.2.23",
        "@angular/service-worker": "^21.2.23",
        "@fortawesome/fontawesome-free": "^6.7.2",
        "@microsoft/signalr": "^8.0.29",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^17.0.0",
        "@progress/kendo-angular-buttons": "^22.0.0",
        "@progress/kendo-angular-common": "^22.0.0",
        "@progress/kendo-angular-dateinputs": "^22.0.0",
        "@progress/kendo-angular-dialog": "^22.0.0",
        "@progress/kendo-angular-dropdowns": "^22.0.0",
        "@progress/kendo-angular-editor": "^22.0.0",
        "@progress/kendo-angular-excel-export": "^22.0.0",
        "@progress/kendo-angular-grid": "^22.0.0",
        "@progress/kendo-angular-icons": "^22.0.0",
        "@progress/kendo-angular-inputs": "^22.0.0",
        "@progress/kendo-angular-intl": "^22.0.0",
        "@progress/kendo-angular-l10n": "^22.0.0",
        "@progress/kendo-angular-label": "^22.0.0",
        "@progress/kendo-angular-layout": "^22.0.0",
        "@progress/kendo-angular-navigation": "^22.0.0",
        "@progress/kendo-angular-pdf-export": "^22.0.0",
        "@progress/kendo-angular-popup": "^22.0.0",
        "@progress/kendo-angular-ripple": "^22.0.0",
        "@progress/kendo-angular-toolbar": "^22.0.0",
        "@progress/kendo-angular-tooltip": "^22.0.0",
        "@progress/kendo-angular-treeview": "^22.0.0",
        "@progress/kendo-data-query": "^1.7.3",
        "@progress/kendo-font-icons": "^4.11.0",
        "@progress/kendo-licensing": "^1.11.3",
        "@progress/kendo-theme-bootstrap": "^11.3.2",
        "@sentry/angular": "^10.74.0",
        "@sentry/browser": "^10.74.0",
        "@sentry/cli": "^2.58.6",
        "@wk/components-v3-angular17": "^0.0.322",
        "async-mutex": "^0.5.0",
        "bootstrap": "^5.3.8",
        "chartist": "^1.5.0",
        "cldr-data": "^36.0.4",
        "date-fns": "^4.4.0",
        "date-fns-tz": "^3.2.0",
        "html-to-text": "^9.0.5",
        "linkedom": "^0.18.13",
        "mixpanel-browser": "^2.83.0",
        "ng-chartist": "^10.0.0",
        "ngx-bootstrap": "^21.2.2",
        "ngx-pagination": "6.0.3",
        "rxjs": "7.8.1",
        "tslib": "^2.8.1",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^21.2.24",
        "@angular/cli": "^21.2.24",
        "@angular/compiler-cli": "^21.2.23",
        "@compodoc/compodoc": "^1.2.1",
        "@types/mixpanel-browser": "^2.60.0",
        "@vitest/browser-webdriverio": "^4.1.11",
        "@vitest/coverage-v8": "^4.1.11",
        "angular-eslint": "^21.4.0",
        "concurrently": "^9.2.4",
        "eslint": "^9.39.5",
        "jsdom": "^28.1.0",
        "prettier": "^3.9.6",
        "sass": "^1.104.1",
        "typescript": "5.9.3",
        "vitest": "^4.1.11"
    }
}
